(() => {
  'use strict';
  const KEY = 'gm_wishlist';
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const WISHLIST_URL = ROOT + 'pages/lista-de-deseos';
  const LANG = String(document.documentElement.lang || 'es').toLowerCase().indexOf('en') === 0 ? 'en' : 'es';
  const T = {
    es: { aria: 'Lista de deseos', save: 'Guardar en lista de deseos', saved: 'En tu lista de deseos', remove: 'Quitar de la lista' },
    en: { aria: 'Wishlist', save: 'Save to wishlist', saved: 'In your wishlist', remove: 'Remove from wishlist' }
  }[LANG];

  const read = () => { try { const v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; } catch (e) { return []; } };
  const write = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} updateCount(); };
  const has = (h) => read().indexOf(h) !== -1;
  const toggle = (h) => { const l = read(); const i = l.indexOf(h); if (i >= 0) { l.splice(i, 1); } else { l.push(h); } write(l); return i < 0; };

  const HEART = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.51 4.04 3 5.5l7 7Z"/></svg>';
  const HEART_FULL = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.51 4.04 3 5.5l7 7Z"/></svg>';

  function updateCount() {
    const n = read().length;
    document.querySelectorAll('[data-gm-wishlist-count]').forEach((el) => {
      const t = el.querySelector('span');
      if (t) t.textContent = n > 0 ? String(n) : '';
      el.classList.toggle('gm-has-items', n > 0);
    });
  }

  function money(cents) {
    const cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'COP';
    try { return new Intl.NumberFormat(LANG === 'en' ? 'en-US' : 'es-CO', { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(cents / 100); }
    catch (e) { return '$' + Math.round(cents / 100).toLocaleString('es-CO'); }
  }

  function injectHeaderIcon() {
    document.querySelectorAll('header-actions').forEach((ha) => {
      if (ha.querySelector('.gm-wl-link')) return;
      const a = document.createElement('a');
      a.className = 'gm-wl-link header-actions__action';
      a.href = WISHLIST_URL;
      a.setAttribute('aria-label', T.aria);
      a.innerHTML = HEART + '<span class="gm-wl-count" data-gm-wishlist-count aria-hidden="true"><span></span></span>';
      ha.insertBefore(a, ha.firstChild);
    });
    updateCount();
  }

  function initProductPage() {
    const m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    if (document.querySelector('.gm-wl-toggle')) return;
    const handle = decodeURIComponent(m[1]);
    const anchor = document.querySelector('product-form-component')
      || document.querySelector('form[action*="/cart/add"]')
      || document.querySelector('.product-information');
    if (!anchor) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gm-wl-toggle';
    const render = () => {
      const on = has(handle);
      btn.innerHTML = (on ? HEART_FULL : HEART) + '<span>' + (on ? T.saved : T.save) + '</span>';
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    };
    btn.addEventListener('click', () => { toggle(handle); render(); });
    render();
    anchor.insertAdjacentElement('afterend', btn);
  }

  let rendering = false;
  async function initWishlistPage() {
    const grid = document.querySelector('[data-gm-wishlist-grid]');
    if (!grid || rendering) return;
    const empty = document.querySelector('[data-gm-wishlist-empty]');
    const handles = read();
    const sig = handles.join(',');
    if (grid.dataset.gmRendered === sig) return;
    rendering = true;
    grid.dataset.gmRendered = sig;
    try {
      if (!handles.length) {
        grid.innerHTML = '';
        if (empty) empty.hidden = false;
        return;
      }
      if (empty) empty.hidden = true;
      const cards = await Promise.all(handles.map(async (h) => {
        try {
          const r = await fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js');
          if (!r.ok) return null;
          const p = await r.json();
          const card = document.createElement('div');
          card.className = 'gm-wl-card';
          const imgSrc = p.featured_image ? sized(p.featured_image, 700) : '';
          card.innerHTML =
            '<a href="' + p.url + '">' + (imgSrc ? '<img loading="lazy" src="' + imgSrc + '" alt="">' : '') + '</a>' +
            '<a href="' + p.url + '" class="gm-wl-title">' + esc(p.title) + '</a>' +
            '<div class="gm-wl-price">' + money(p.price) + '</div>' +
            '<button type="button" class="gm-wl-remove" aria-label="' + T.remove + '">&times;</button>';
          card.querySelector('.gm-wl-remove').addEventListener('click', () => {
            toggle(h);
            card.remove();
            grid.dataset.gmRendered = read().join(',');
            if (!read().length && empty) empty.hidden = false;
          });
          return card;
        } catch (e) { return null; }
      }));
      const frag = document.createDocumentFragment();
      cards.forEach((c) => { if (c) frag.appendChild(c); });
      grid.innerHTML = '';
      grid.appendChild(frag);
    } finally {
      rendering = false;
    }
  }

  function sized(src, w) { try { const u = new URL(src, location.origin); u.searchParams.set('width', String(w)); return u.toString(); } catch (e) { return src; } }
  function esc(s) { const d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  let t = null;
  function schedule() { clearTimeout(t); t = setTimeout(run, 150); }
  function run() { injectHeaderIcon(); initProductPage(); initWishlistPage(); }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
